import React, { Component } from 'react';
import Cyber from '../../assets/Product/cyber-attack.svg';
import Bitcoin from '../../assets/Product/bitcoin.svg';
import Domain from '../../assets/Product/domain.svg';
import Banner from './Banner/Banner'
import './Banners.css';

export default class Banners extends Component {
    render() {
        return (
            <div className="banners">
                <h3 className="header">Why You Need ThreatSpy ?</h3>
                <div className="container">
                    <div className="row banners-show">
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                            <Banner src={Cyber} head="75%" content="Cyberattacks take place due to negligent employees." />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                            <Banner src={Domain} head="60 K" content="Websites in world are hacked daily. Attack with many virus like rosomewares" />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                            <Banner src={Bitcoin} head="$ 601BN" content="Hacks cost to businesses a year around the world." />
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}